import { fromFetch } from 'rxjs/fetch';

import { AuthHeaders } from '../../../models/auth-headers';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { ignoreData } from '../../../utils/ignore-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { AssetInvitationType } from '../schemas/asset-invitation-type.schema';

/**
 * Invite a single User to a specified Product
 * @param id User's ID
 * @param productId Product's ID
 * @param invitationType Asset Invitation Type
 */
export function postUsersInvite(
  this: unknown,
  id: number,
  productId: number,
  invitationType?: AssetInvitationType
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(`${accountsEnvironment.resolve(this).usersUrl}/invite`, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
            ? new AuthHeaders()
            : jwtAuthHeaders),
        },
        body: JSON.stringify({
          id,
          productId,
          invitationType,
        }),
      })
    )
  ).pipe(ignoreData());
}
